import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import LOGO from "../../assets/thurent-logo.svg";
import "./Login.css";

import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import {
  loginWithOTP,
  loginWithPassword,
  sendLoginOTP,
} from "../../../services/ServiceProviderAuthServices";
import { handlePendingEvent, setCredentials } from "../../../store/authSlice";
import { homePagePath } from "../../../constant";

const ThurentServiceProviderLogin = () => {
  const [usingOTP, setUsingOTP] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const phoneRegExp = /^[6-9]\d{9}$/;
  const [agreedToPolicy, setAgreedToPolicy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("in");
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [countryCode, setcountryCode] = useState("+91");
  const [showErrorDialogVisible, setShowErrorDialogVisible] = useState(false);
  const [errorDialogCont, setErrorDialogCont] = useState({});

  useEffect(() => {}, []);
  const handleToggle = async () => {
    formik.setFieldValue("password", ""); // Clear the password field
    formik.setFieldValue("otp", ""); // Clear the OTP field

    formik.setErrors({
      identifier: formik.errors.identifier, // Keep identifier error if any
      password: formik.errors.password, // Clear password error
      otp: formik.errors.otp, // Clear OTP error
    });

    if (!usingOTP && !formik.errors.identifier) {
      formik.setFieldTouched("password", false); // Reset touched for Password field
      await handleResendOTP(formik.values.identifier,countryCode);
      setOtpSent(true);
      setUsingOTP(true);
    } else {
      formik.setFieldTouched("otp", false); // Reset touched for OTP field
      setOtpSent(false);
      setUsingOTP(false);
    }
  };

  const showErrorDialog = (msg) => {
    setShowErrorDialogVisible(true);
    switch (msg) {
      case "User not found.":
        setErrorDialogCont({
          header: "Wrong Credentials",
          content:
            "Invalid mobile number or password. Please enter valid credentials.",
          btn: false,
        });
        break;
      default:
        setErrorDialogCont({
          header: "Login Failed",
          content: msg,
          btn: false,
        });
    }
  };

  // Formik initialization
  const formik = useFormik({
    initialValues: {
      identifier: "",
      password: "",
      otp: "",
      countryCode: "",
    },
    validationSchema: Yup.object({
      identifier: Yup.string()
        .required("Mobile Number is required")
        .test(
          "is-valid-phone-or-email",
          "Invalid mobile number",
          function (value) {
            if (!value) return false; // Empty check is already handled by .required()
            const isValidPhone = phoneRegExp.test(value);
            console.log(isValidPhone);
            return isValidPhone;
          }
        ),
      password: Yup.lazy(() => {
        return !usingOTP
          ? Yup.string()
              .required("Password is required")
              .min(6, "Password must be at least 6 characters")
          : Yup.string().notRequired(); // This ensures that no validation is done on password when using OTP
      }),
      otp:
        usingOTP && otpSent
          ? Yup.string()
              .required("OTP is required")
              .matches(/^[a-zA-Z0-9]{6}$/, "OTP must be 6 characters")
          : null,
    }),
    onSubmit: async (values) => {
      try {
        if (!usingOTP) {
          const data = await loginWithPassword(
            values.identifier,
            values.password,
            values.countryCode
          );
          handlePostlogin(data);
          navigate("/service-provider/dashboard");
        } else {
          const data = await loginWithOTP(values.identifier, values.otp ,countryCode);
          handlePostlogin(data);
          navigate("/service-provider/dashboard");
        }
      } catch (error) {
        showErrorDialog(error.message || "");
      }
    },
  });

  const handlePostlogin = async (data) => {
    console.log("logindata",data)
    dispatch(setCredentials(data));
    dispatch(handlePendingEvent());
  };

  const handleResendOTP = async (identifier) => {
    try {
      await sendLoginOTP(identifier, countryCode);
      setOtpSent(true);
    } catch (error) {
      setOtpSent(false);
      showErrorDialog(error.message || "Failed to send OTP. Please try again.");
    }
  };

  return (
    <div className="th-auth">
      <Dialog
        className="th-auth__dialog"
        visible={showErrorDialogVisible}
        modal
        header={errorDialogCont.header}
        footer={
          errorDialogCont.btn ? (
            <Button
              size="small"
              label="Signup"
              onClick={() => navigate("/service-provider/signup")}
            />
          ) : (
            <Button
              size="small"
              label="OK"
              onClick={() => setShowErrorDialogVisible(false)}
            />
          )
        }
        onHide={() => {
          if (!showErrorDialogVisible) return;
          setShowErrorDialogVisible(false);
        }}
      >
        <p style={{ fontWeight: "500", margin: "0" }}>
          {errorDialogCont.content}
        </p>
      </Dialog>
      <div className="th-auth__container">
        <img
          src={LOGO}
          alt="thurent"
          className="th-auth__logo"
          onClick={() => {
            navigate(homePagePath);
          }}
        />
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            {/* <input
              type="text"
              name="identifier"
              maxLength="10"
              placeholder="Mobile Number"
              disabled={otpSent && usingOTP} // Disable this field after OTP is sent
              value={formik.values.identifier}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="th-login__input"
            /> */}
            <PhoneInput
              country={selectedCountry}
              onlyCountries={["in", "us"]}
              disableCountryCode={true}
              disableDropdown={false}
              value={formik.values.mobileNumber}
              onChange={(value, data) => {
                const dialCode = data.dialCode; // e.g., "91"
                const countryCode = `+${dialCode}`; // "+91"
                setcountryCode(countryCode);
                // Make sure value doesn't contain dialCode if it's added back
                const cleanedValue = value.startsWith(dialCode)
                  ? value.slice(dialCode.length)
                  : value;

                console.log("Input:", value);
                console.log("Local:", cleanedValue);
                console.log("Country:", countryCode);

                formik.setFieldValue("countryCode", countryCode);
                formik.setFieldValue("identifier", cleanedValue);
                setSelectedCountry(data.countryCode);
              }}
              placeholder="Mobile Number"
              inputProps={{
                name: "mobileNumber",
                required: true,
                onBlur: formik.handleBlur,
              }}
              containerClass="phone-container"
              inputClass="phone-input"
              buttonClass="phone-flag-button"
            />
            {formik.touched.identifier && formik.errors.identifier ? (
              <div className="error">{formik.errors.identifier}</div>
            ) : null}
          </div>

          {/* Password field - only show when not using OTP */}
          <div className="mb-3">
            {!usingOTP && (
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="th-login__input"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={handleClickShowPassword}
                  edge="end"
                  sx={{ position: "absolute", right: "12px", top: "-2px" }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </div>
            )}

            {!usingOTP && formik.touched.password && formik.errors.password ? (
              <div className="error">{formik.errors.password}</div>
            ) : null}
          </div>

          {/* OTP field - always show when using OTP */}
          <div className="mb-3">
            {usingOTP && (
              <input
                type="text"
                placeholder="Enter OTP"
                className="th-login__input"
                name="otp"
                disabled={!otpSent} // Disable until OTP is sent
                value={formik.values.otp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            )}
            {formik.touched.otp && formik.errors.otp ? (
              <div className="error">{formik.errors.otp}</div>
            ) : null}
          </div>

          {/* Buttons & Links */}
          <div
            className={`flex justify-content-between mb-2 ${
              usingOTP && !otpSent ? "single" : ""
            }`}
          >
            {/* Forgot Password */}
            {!usingOTP && (
              <Link
                to="/service-provider/forgot-password"
                className="th-auth__button font-medium no-underline"
              >
                Forgot Password?
              </Link>
            )}

            {/* Resend OTP */}
            {usingOTP && otpSent && (
              <button
                type="button"
                onClick={() => handleResendOTP(formik.values.identifier)}
                className="th-auth__button p-0"
              >
                Resend OTP
              </button>
            )}

            {/* Toggle between Use OTP and Use Password */}
            <button
              type="button"
              onClick={handleToggle}
              disabled={
                formik.errors.identifier ||
                formik.values.identifier?.length !== 10
              }
              style={{
                cursor:
                  formik.errors.identifier ||
                  formik.values.identifier?.length !== 10
                    ? "not-allowed"
                    : "pointer",
                color:
                  (formik.errors.identifier ||
                    formik.values.identifier?.length !== 10) &&
                  "grey",
              }}
              className="th-auth__button p-0"
            >
              {usingOTP ? "Use Password" : "Send OTP"}
            </button>
          </div>

          <button type="submit" className="th-login__button font-inter">
            <span className="Login-bitton"> LOGIN</span>
          </button>
        </form>

        {/* <button
          className="th-signup__button font-inter font-normal"
          onClick={() => navigate("/service-provider/signup")}
        >
          <span style={{ color: "red" }}>New User? </span> SIGNUP HERE!
        </button> */}

        <div
          style={{
            fontSize: "12px",
            fontWeight: "500",
            color: "#888",
            marginTop: "15px",
            textAlign: "left",
          }}
        >
          By creating an account or logging in, you agree to Thurent’s{" "}
          <Link
            to="/privacy-policy"
            style={{ color: "#26b8e3", margin: "0 4px" }}
          >
            Privacy Policy.
          </Link>
        </div>
        {/* <div className="flex w-full justify-content-center align-items-center mt-3">
          <Button
            label="Back to Home"
            icon="pi pi-home"
            className="th-backtohome__button"
            iconPos="right"
            severity="contrast"
            onClick={() => navigate(homePagePath)}
            size="small"
          />
        </div> */}
      </div>
    </div>
  );
};

export default ThurentServiceProviderLogin;
